<template>
    <div>

        <PageHeader>
            {{ $t('reportsAvailability') }}
            <template #side>
                <div class="d-flex gap-3">
                    <ButtonResetFilters @click="resetFilters()" />
                    <TimeRangeCalendar ref="TimeRangeCalendar" v-model="timeRange" compare-year />
                </div>
            </template>
        </PageHeader>

        <AvailabilityAnalysis />

        <CurrentAvailability />

    </div>
</template>



<script>
    import ButtonResetFilters from '@/components/common/ButtonResetFilters.vue';
    import TimeRangeCalendar from '@/components/common/TimeRangeCalendar.vue';
    import AvailabilityAnalysis from './parts/AvailabilityAnalysis.vue';
    import CurrentAvailability from './parts/CurrentAvailability.vue';

    export default {
        name: 'ReportsAvailability',
        components: {
            ButtonResetFilters,
            TimeRangeCalendar,
            AvailabilityAnalysis,
            CurrentAvailability,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                timeRange: null,
            };
        },
        methods: {
            resetFilters() {
                this.$emit('resetFilters');
                this.$refs.TimeRangeCalendar.resetDate();
            },
        },
    };
</script>
